export default [
  {
    id: 'massiveDisableSchemas',
    title: 'Disable',
    icon: 'mdi-cancel',
    action: 'massiveDisableSchemas',
    _enabled: true
  },
  {
    id: 'massiveEnableSchemas',
    action: 'massiveEnableSchemas',
    title: 'Enable',
    icon: 'mdi-power-off',
    _enabled: true
  },
  {
    id: 'bump-version',
    title: 'Bump version',
    icon: 'mdi-numeric-positive-1',
    action: 'bump-version',
    _enabled: true
  },
  {
    id: 'delete',
    title: 'Delete',
    icon: 'mdi-delete',
    action: 'delete',
    _enabled: true
  }
];
